/** One source document of a dossier on its own page, e.g. opened in a new tab from the patient page. */

import { useParams } from "react-router";
import { SourceDocumentPage } from "@app/components/SourceDocument";

export default function PatientDocument() {
  const { tenant_id, id_patient, doc_id } = useParams();
  if (!tenant_id || !id_patient || !doc_id) return null;
  return (
    <SourceDocumentPage
      tenantId={tenant_id}
      patientId={id_patient}
      docId={doc_id}
    />
  );
}
